export const HTTPURL = "http://13.246.104.56:8090/";
// export const HTTPURL = "https://13.246.104.56:8090/";
// export const HTTPURL = "http://localhost:8090/";

export const REQUEST_OPTIONS = {
    // method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // body: JSON.stringify(requestData)
};   

export const REQUEST_OPTIONS_NO_HEAD = {

};

export const ADMIN = "admin@yopmail.com";